<div class="main-container">
  <div class="middle-container-row">
    <div class="card-container">
      <div class="card">
        <div class="card-header">
          <div class="image-container">
            <img
              src="../../../../../assets/img/logo/logo-with-text-and-icon.svg"
              class="img-resp"
              alt="Wellro Wellness"
            />
          </div>
        </div>
        <div class="card-body">
          <ng-content></ng-content>
        </div>
        <div class="card-footer">
          By using this platform, I agree to
          <a href="">Terms of Service</a> and
          <a href="">Privacy&nbsp;Policy</a>.
        </div>
      </div>
    </div>
  </div>
  <div class="coppy-right-container">
    <div class="text">Copyright © 2021 Wellro Wellness</div>
  </div>
</div>
